angular.module('app.filters')
.filter('filterFirms', [
  "$log", "$filter", function($log, $filter) {
    return function(filterCategory, filterVisibility, firmsList) {
      var filteredFirms;
      filteredFirms = angular.copy(firmsList);
      $log.info(filterCategory);
      if (filterCategory !== "" && filterCategory !== "All") {
        filteredFirms = $filter('filter')(filteredFirms, {
          ref_category: {
            cat_ID: filterCategory
          }
        });
      }
      if (filterVisibility !== "" && filterVisibility !== "All") {
        filteredFirms = $filter('filter')(filteredFirms, {
          firm_Visibility: filterVisibility
        }, true);
      }
      return filteredFirms;
    };
  }
])


// WEBPACK FOOTER //
// ./scripts/shared/filters/firms.js